import React, { useEffect, useState } from "react";
import axios from "axios";
import { getManager } from "../../api/managerApi";
import { MENU_CONFIG } from "../manager/items/SideMenuList";
import MailSlackList from "./MailSlackList";

const FALLBACK_MAIL_CONFIG = MENU_CONFIG.menusByKey.mail;

function RecentMailListCardImap({title = "최근 메일",limit = 5,}) {
  const [mails, setMails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mailConfig, setMailConfig] = useState(FALLBACK_MAIL_CONFIG);

  useEffect(() => {

    const comCode = sessionStorage.getItem("M_ComCode");
    if (!comCode) return;

    getManager(comCode)
      .then((manager) => {
        const mailDomainRaw = String(manager?.M_MailDomain || '').trim();
        const mailDomain = /^https?:\/\//i.test(mailDomainRaw) ? mailDomainRaw : `https://${mailDomainRaw}`;

        if (!mailDomainRaw) return;

        setMailConfig((prev) => ({
          ...prev,
          url: mailDomain,
          sessionUrl: `${mailDomain}/mailcow_auto_login_enhanced_debug.php`,
        }));
      })
      .catch(err => console.error('회사 메일 도메인 조회 실패:', err));

  }, []);

  useEffect(() => {
    const fetchMailList = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          setError('인증 정보가 없습니다. 다시 로그인해주세요.');
          setLoading(false);
          return;
        }

        const res = await axios.get('/api/mail/list/imap', {
          params: {
            folder: 'INBOX',
            page: 1,
            limit: limit,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (res.data?.success && Array.isArray(res.data.emails)) {
          setMails(res.data.emails);
        } else {
          setError('메일 목록을 불러올 수 없습니다.');
        }
      } catch (err) {
        console.error("메일 목록 불러오기 실패:", err);
        if (err.response?.status === 401) {
          setError('인증이 만료되었습니다. 다시 로그인해주세요.');
        } else {
          setError(err.response?.data?.message || err.message || '메일 조회 실패');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchMailList();
  }, [limit]);



  const handleMoreClick = () => {
    const sessionValue = sessionStorage.getItem("session");
    const sessionUrl = mailConfig?.sessionUrl ?? mailConfig?.session_url;
    const url = mailConfig?.url;
    if (sessionValue && sessionValue !== 'null' && sessionUrl) {
      window.open(`${sessionUrl}?key=${encodeURIComponent(sessionValue)}`, '_blank');
    } else if (url) {
      window.open(url, '_blank');
    }

  };
  return (
    <MailSlackList
      title={title}
      mails={mails}
      loading={loading}
      error={error}
      limit={limit}
      onMoreClick={handleMoreClick}
    />

  );

}



export default RecentMailListCardImap;


